import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IActualSystemMenuPermission, userPermissionsCreateDto } from 'src/app/tabms/models/base/base';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionsService {
  constructor(private http: HttpClient) {}

  createBulk(data: userPermissionsCreateDto[]): Observable<boolean> {
    return this.http.post<boolean>(`${environment.baseUrl}TABUserPermission/SetBulkUserPermission`, data);
  }

  getActualSystemMenuPermission(userid: string, menuid = null): Observable<IActualSystemMenuPermission[]> {
    let params = menuid ? { menuid: menuid, userid: userid } : { userid: userid };
    return this.http.get<IActualSystemMenuPermission[]>(`${environment.baseUrl}TABUserPermission/GetActualSystemMenuPermission`, {
      params
    });
  }
  createPagePermission(data: userPermissionsCreateDto): Observable<boolean> {
    return this.http.post<boolean>(`${environment.baseUrl}TABUserPermission/Create`, data);
  }
  
}
